import { I18NText, State } from 'src/types'
import { genColorCellsByPosition } from 'src/features/generatePdf/helper'
import { contentsChecker } from 'src/features/retails/hooks'
import { ko2JaColorPartsTranslates, ko2JaColorPartsTranslatesNoTanners } from 'src/features/brands/atoms/korea/constants/colors'
import { en2JaColorPartsTranslates } from 'src/features/brands/atoms/us/constants/colors'

export const colorCells2Condition = [
  'lace',
  'stitch',
  'hamidashi',
  'edge',
  'mouton',
  'atomsLabel',
  'ysrLabel',
  'dxmLabel',
  'dxmLabelCore',
  'ragLabel',
  'gorillaLabel'
]

export const colorSettings = (state: State, t: I18NText): any => {
  const { isUsContents } = contentsChecker(state.dominantArm)
  const brand = state.baseModel.brand
  const position = state.baseModel.position
  const colorCells = genColorCellsByPosition(position, state, brand, t)
  const colorCells1 = colorCells.filter((x) => !colorCells2Condition.includes(x.partsKey))
  const translated1 = colorCells1.map((cell) => {
    const cellLabel = cell.label
    const cellHead = cell.head
    const japaneseLabel = isUsContents
      ? en2JaColorPartsTranslates.find((x) => x?.en === cellLabel)?.japanese
      : [...ko2JaColorPartsTranslates, ...ko2JaColorPartsTranslatesNoTanners].find((x) => x?.korea === cellLabel)?.japanese
    const label = japaneseLabel ?? cellLabel

    const japaneseHead = isUsContents
      ? en2JaColorPartsTranslates.find((x) => x?.en === cellHead)?.japanese
      : ko2JaColorPartsTranslates.find((x) => x?.korea === cellHead)?.japanese
    const head = japaneseHead ?? cellHead
    return { ...cell, label, head }
  })

  const colorCells2 = colorCells.filter((x) => colorCells2Condition.includes(x.partsKey))
  const translated2 = colorCells2.map((cell) => {
    const cellLabel = cell.label
    const cellHead = cell.head
    const japaneseLabel = isUsContents
      ? en2JaColorPartsTranslates.find((x) => x?.en === cellLabel)?.japanese
      : [...ko2JaColorPartsTranslates, ...ko2JaColorPartsTranslatesNoTanners].find((x) => x?.korea === cellLabel)?.japanese
    const label = japaneseLabel ?? cellLabel
    const japaneseHead = isUsContents
      ? en2JaColorPartsTranslates.find((x) => x?.en === cellHead)?.japanese
      : ko2JaColorPartsTranslates.find((x) => x?.korea === cellHead)?.japanese

    const head = japaneseHead ?? cellHead
    return { ...cell, label, head }
  })

  const DUMMY = { head: '', label: '', value: '' }
  const remaining1 = translated1.length % 3 // 配列要素数合計を3の倍数で割った時の余り
  const formattedBaseCells1: {
    head: string
    label: string
    color?: string
    value?: string
    partsKey?: string
  }[] = remaining1 === 2 ? [...translated1, DUMMY] : remaining1 === 1 ? [...translated1, DUMMY, DUMMY] : translated1

  // console.log({ translated1 })
  // 以下の要素数は必ず3の倍数になっている必要があるため、上記でdummy Objectを使って余りを埋めている
  const twoDimensionalArray1 = formattedBaseCells1
    .reduce((a, _, i) => {
      const item = [...formattedBaseCells1].splice(i * 3, 3).map((x) => [
        { text: x.head, fontSize: 8 },
        { text: x.label, fontSize: 10, alignment: 'right' /*color: 'pink'*/ }
      ])
      a.push(item)
      return a
    }, [])
    .filter((x) => x.length)

  const remaining2 = translated2.length % 3 // 配列要素数合計を3の倍数で割った時の余り
  const formattedBaseCells2: {
    head: string
    label: string
    color?: string
    value?: string
    partsKey?: string
  }[] = remaining2 === 2 ? [...translated2, DUMMY] : remaining2 === 1 ? [...translated2, DUMMY, DUMMY] : translated2
  // console.log({ translated2 })

  const twoDimensionalArray2 = formattedBaseCells2
    .reduce((a, _, i) => {
      const item = [...formattedBaseCells2].splice(i * 3, 3).map((x) => [
        { text: x.head, fontSize: 8 },
        { text: x.label, fontSize: 10, alignment: 'right' /*color: '#323232'*/ }
      ])
      a.push(item)
      return a
    }, [])
    .filter((x) => x.length)
  return [
    {
      text: 'カラー設定1',
      style: { fontSize: 11 },
      margin: [0, 8, 0, 4]
    },
    {
      table: {
        widths: ['33%', '33%', '33%'],
        body: twoDimensionalArray1 // genColorSettingByBrand(state, brand, position, genCellContent)
      }
    },
    {
      text: 'カラー設定2',
      style: { fontSize: 11 },
      margin: [0, 8, 0, 4]
    },
    {
      table: {
        widths: ['33%', '33%', '33%'],
        body: twoDimensionalArray2 // genColorSettingByBrand(state, brand, position, genCellContent)
      }
    }
  ]
}
